const guestLayers = ["infrastructure", "wellsite", "sentinel", "watertemperature", "watersediment", "lake", "waterlaketss", "waterriverssc", "waterlakechl", "riverice", "landdeformation", "land_deformation_vec2", "reclaimedwellsites", "reclaimedwellsites", "sentinel", "landdeformation", "land_deformation_vec2", "sentinel", "riverice", "sentinel", "rivericehistorical", "watertemperature", "watersediment", "lake", "waterlaketss", "sentinel", "waterriverssc", "waterlakechl"]

export default guestLayers



// WEBPACK FOOTER //
// ./src/config/guestLayers.js